/**
 * Utility functions for detecting text truncation
 */

/**
 * Detects if text content is truncated with ellipsis
 * @param {HTMLElement} element - The DOM element to check
 * @returns {boolean} - True if text is truncated
 */
export const isTextTruncated = (element) => {
  if (!element) return false;
  
  // Check if the element has text overflow ellipsis and if content overflows
  return element.scrollWidth > element.clientWidth;
};
